import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/admin');
    } catch (error) {
      const message = error.response?.data?.message || 'Connection failed. Check your API URL.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet><title>Admin Login – Villa Tesori</title></Helmet>
      <div style={{ minHeight: '100vh', background: 'var(--forest)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(201,168,76,0.25)',
          borderRadius: 4, padding: '48px 44px', width: '100%', maxWidth: 420,
        }}>
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <img 
              src="/logo-green.jpeg" 
              alt="Villa Tesori Logo" 
              style={{ height: '100px', width: 'auto', marginBottom: 16 }} 
            />
            <div style={{ fontSize: '0.7rem', letterSpacing: '0.22em', color: 'rgba(200,217,192,0.5)', textTransform: 'uppercase' }}>Admin Access</div>
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: '0.72rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(200,217,192,0.6)', marginBottom: 8 }}>Email</label>
              <input
                type="email" required value={form.email}
                onChange={e => setForm(p => ({...p, email: e.target.value}))}
                style={{
                  width: '100%', padding: '13px 16px',
                  background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(201,168,76,0.2)',
                  borderRadius: 2, color: 'var(--mist)', fontFamily: 'Jost, sans-serif', fontSize: '0.9rem', outline: 'none',
                }}
                placeholder="admin@villatesori.com"
              />
            </div>
            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', fontSize: '0.72rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(200,217,192,0.6)', marginBottom: 8 }}>Password</label>
              <input
                type="password" required value={form.password}
                onChange={e => setForm(p => ({...p, password: e.target.value}))}
                style={{
                  width: '100%', padding: '13px 16px',
                  background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(201,168,76,0.2)',
                  borderRadius: 2, color: 'var(--mist)', fontFamily: 'Jost, sans-serif', fontSize: '0.9rem', outline: 'none',
                }}
                placeholder="••••••••"
              />
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '14px', background: 'var(--gold)', color: 'var(--forest)',
              border: 'none', borderRadius: 2, fontFamily: 'Jost, sans-serif', fontSize: '0.8rem',
              letterSpacing: '0.15em', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
